import React, { useState, useEffect } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FaPaperPlane, FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { differenceInHours } from 'date-fns';
import { isMobile } from 'react-device-detect';
import './styles.scss';
import { parseDate } from '../../utils/dateUtils';

const ChatWidget = ({ dir, params, activeFilters, locations, onShowModal, isModalOpen }) => {
  const { t, i18n } = useTranslation();
  const [message, setMessage] = useState('');

  const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  const getLocationName = (code) => {
    if (!locations || !Array.isArray(locations)) return code;
    const loc = locations.find(l => String(l.locationCode) === String(code));
    return loc ? `${loc.city}` : code;
  };

  // Build personalized message
  const buildPersonalizedMessage = () => {
    if (!params) return t('chat.supportMessage');
    
    const { startDate, endDate, fromLocationCode, toLocationCode } = params;
    if (!startDate || !endDate || !fromLocationCode) return t('chat.supportMessage');
    
    // Parse dates
    const start = parseDate(startDate);
    const end = parseDate(endDate);
    const hours = differenceInHours(end, start);
    const duration = Math.ceil(hours / 24);
    
    const pickupLocation = getLocationName(fromLocationCode);
    const dropoffLocation = toLocationCode && toLocationCode !== fromLocationCode ? getLocationName(toLocationCode) : null;
    
    const pickupDay = start.toLocaleDateString(i18n.language, { weekday: 'long', month: 'short', day: 'numeric' });
    const durationText = duration === 1 ? t('chat.oneDay') : `${duration} ${t('chat.days')}`;
    
    let locationText;
    if (dropoffLocation) {
      locationText = t('chat.fromTo', { from: pickupLocation, to: dropoffLocation });
    } else {
      locationText = t('chat.from', { location: pickupLocation });
    }
    
    let message = t('chat.personalizedMessage', { location: locationText, day: pickupDay, duration: durationText });
    
    // Add specific filters if any
    // const phrases = [];
    // if (activeFilters) {
    //   if (activeFilters.transmission) {
    //     if (activeFilters.transmission.includes('A')) phrases.push(t('automaticTransmission'));
    //     if (activeFilters.transmission.includes('M')) phrases.push(t('manualTransmission'));
    //   }
    //   if (activeFilters.deskLocation) {
    //     activeFilters.deskLocation.forEach(val => {
    //       if (val === 'inTerminal') phrases.push(t('deskAtTerminal'));
    //       else if (val === 'onAirport') phrases.push(t('deskAtAirport'));
    //       else if (val === 'rentalCenter') phrases.push(t('deskAtRentalCenter'));
    //       else if (val === 'meetAndGreet') phrases.push(t('meetAndGreetService'));
    //       else if (val === 'shuttle') phrases.push(t('shuttleService'));
    //     });
    //   }
    //   if (activeFilters.recommendedSupplier && activeFilters.recommendedSupplier.includes('recommended')) {
    //     phrases.push(t('fromRecommendedSuppliers'));
    //   }
    //   if (activeFilters.winterEquipmentIncluded && activeFilters.winterEquipmentIncluded.includes(true)) {
    //     phrases.push(t('withWinterEquipment'));
    //   }
    //   if (activeFilters.insurance && activeFilters.insurance.includes('zeroExcess')) {
    //     phrases.push(t('withZeroExcess'));
    //   }
    //   if (activeFilters.insurance && activeFilters.insurance.includes('excessRefundIncluded')) {
    //     phrases.push(t('withExcessRefundIncluded'));
    //   }
    //   if (activeFilters.carType) {
    //     if (activeFilters.carType.includes('W')) phrases.push(t('wagonCars'));
    //     if (activeFilters.carType.includes('F|G')) phrases.push(t('suvCars'));
    //   }
    // }
    
    // if (phrases.length > 0) {
    //   message += ` (${t('consideringFilters')} ${phrases.join(', ')})`;
    // }
    
    return message;
  };

  const personalizedMessage = buildPersonalizedMessage();

  const sendMessage = () => {
    if (message.trim()) {
      // Replace with your actual WhatsApp number
      const phoneNumber = '972546127601'; // Real support number
      const fullMessage = message + '\n\n' + t('chat.lookingAtOffers') + '\n' + window.location.href;
      const encodedMessage = encodeURIComponent(fullMessage);
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank');
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div className={`chat-widget ${dir === 'rtl' ? 'rtl' : ''}`}>
      <div className="chat-container">
        <div className="chat-messages">
          <div className="message received">
            <div className="message-avatar">
              <FaUser />
            </div>
            <div className="message-content">
              <div className="message-header">
                <span className="message-name">{t('chat.supportName') || 'Support'}</span>
                <span className="message-time">{currentTime}</span>
              </div>
              <p>{personalizedMessage}</p>
            </div>
          </div>
        </div>
        <div className="chat-input">
          <InputGroup>
            <Form.Control
              as="textarea"
              rows={2}
              placeholder={t('chat.typeMessage') || 'Type your message...'}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={handleKeyPress}
              onFocus={(e) => {
                if (isMobile && !isModalOpen && onShowModal) {
                  onShowModal();
                  e.target.blur();
                }
              }}
              dir={dir}
            />
            <InputGroup.Append>
              <Button variant="primary" onClick={sendMessage} disabled={!message.trim()}>
                <FaPaperPlane />
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </div>
      </div>
    </div>
  );
};

export default ChatWidget;